import * as React from 'react';
import sanitizedHTML from 'sanitize-html';

interface IWebCoreBannerViewProps {
  title: string;
  text: string;
}

export default class WebCoreErrorBannerView extends React.Component<IWebCoreBannerViewProps> {
  render() {
    let { title, text } = this.props;
    return (
      <div className="alert-band">
        <div className="alert with-icon alert-warning alert-dismissible fade in" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">
              <i className="win-icon win-icon-Cancel"></i>
            </span>
          </button>
          <span className="alert-icon">
            <i className="win-icon win-icon-Warning"></i>
          </span>
          <div className="alert-title">{title}</div>
          <div className="row">
            <div className="col-xs-24">
              <p dangerouslySetInnerHTML={{ __html: sanitizedHTML(text) }}></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export class WebCoreInformationBannerView extends React.Component<IWebCoreBannerViewProps> {
  render() {
    let { title, text } = this.props;
    return (
      <div className="alert-band">
        <div className="alert with-icon alert-info alert-dismissible fade in" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">
              <i className="win-icon win-icon-Cancel"></i>
            </span>
          </button>
          <span className="alert-icon">
            <i className="win-icon win-icon-Info"></i>
          </span>
          <div className="alert-title">{title}</div>
          <div className="row">
            <div className="col-xs-24">
              <p dangerouslySetInnerHTML={{ __html: sanitizedHTML(text) }}></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
